import { useEffect, useState } from 'react'
import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
import { getListStaff } from '../../core/_requests'
import { StaffInList } from '../../core/_models'
import { StaffItem } from '../../components/StaffItem'
import { useSecondFactorUserIds } from '../../core/useSecondFactorUserIds'
import { ROLE, useAuth } from '../../../auth'
import { IsGranted } from '../../../auth/PrivateRoute'
import { Table } from '../../../../../components/Table'
import { TableHead } from '../../../../../components/Table/TableHead'
import { TableBody } from '../../../../../components/Table/TableBody'
import { TablePagination } from '../../../../../components/Table/TablePagination/TablePagination'
import { NewEmployee } from '../../components/NewEmployee'

const PAGE_SIZE = 100

const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Активные',
    path: '/staff/active',
    isSeparator: false,
    isActive: true,
    roles: [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER],
  },
  {
    title: 'Заблокированные',
    path: '/staff/blocked',
    isSeparator: false,
    isActive: false,
    roles: [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER],
  },
]

const defaultStaffList: Array<StaffInList> = []

export const ActiveStaff = () => {
  const { currentUser } = useAuth()
  const secondFactor = useSecondFactorUserIds()
  const [staffList, setStaffList] = useState(defaultStaffList)
  const [currentPage, setCurrentPage] = useState(0)
  const [totalRows, setTotalRows] = useState(0)

  const loadPage = async (pageIndex: number) => {
    try {
      const res = await getListStaff(true, pageIndex + 1, PAGE_SIZE)
      if (!res.data.success) {
        setStaffList([])
        setTotalRows(0)
        return
      }

      const employees = res.data.employees
      const total = res.data.totalRows ?? res.data.employees.length
      if (pageIndex > 0 && employees.length === 0 && total > 0) {
        setCurrentPage(pageIndex - 1)
        await loadPage(pageIndex - 1)
        return
      }

      setStaffList(employees)
      setTotalRows(total)
    } catch (error) {
      setStaffList([])
      setTotalRows(0)
    }
  }

  const getStaffList = () => loadPage(currentPage)

  const handlePageChange = (selected: number) => {
    setCurrentPage(selected)
    loadPage(selected)
  }

  useEffect(() => {
    loadPage(0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const pageCount = Math.ceil(totalRows / PAGE_SIZE)

  return (
    <>
      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER], currentUser) && (
        <div className='row'>
          <div className='col text-end pb-4'>
            <NewEmployee callback={getStaffList} />
          </div>
        </div>
      )}

      <div className='card'>
        <PageTitle breadcrumbs={accountBreadCrumbs}>Активные</PageTitle>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Активные сотрудники</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Количество: {totalRows}</span>
          </h3>
        </div>

        <div className='card-body py-3'>
          <Table>
            <TableHead>
              <tr>
                <th className='min-w-150px'>ID</th>
                <th className='min-w-140px'>Username</th>
                <th className='min-w-120px'>Роль</th>
                {secondFactor.allowed && <th className='min-w-150px'>Второй фактор</th>}
                <th className='min-w-120px'>Действия</th>
              </tr>
            </TableHead>
            <TableBody>
              {staffList.map((staff, index) => (
                <StaffItem
                  staff={staff}
                  active={true}
                  key={index}
                  callback={() => {
                    getStaffList()
                    secondFactor.reload()
                  }}
                  showActions
                  secondFactor={secondFactor.of(staff.id)}
                />
              ))}
            </TableBody>
          </Table>

          {pageCount > 1 && (
            <div className='d-flex justify-content-end align-items-center p-5'>
              <TablePagination
                currentPage={currentPage}
                pageCount={pageCount}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </>
  )
}
